// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Ialc2","links":"Footer_links__5ylIs","footer_header":"Footer_footer_header__Qa-JJ"};